import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';

function ConsecutivosRS() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [consecutivos, setConsecutivos] = useState([]);
    const [profesionales, setProfesionales] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentConsecutivo, setCurrentConsecutivo] = useState(null);
    
    // Form fields
    const [selectedProfesional, setSelectedProfesional] = useState('');
    const [numeroConsecutivo, setNumeroConsecutivo] = useState('1');

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = () => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar profesionales (agendas)
        axios.get('/listado-agendas?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando profesionales: ' + error);
            });

        // Cargar consecutivos RS existentes
        axios.get('/consecutivos-rs?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setConsecutivos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando consecutivos: ' + error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleNuevo = () => {
        setEditMode(false);
        setCurrentConsecutivo(null);
        setSelectedProfesional('');
        setNumeroConsecutivo('1');
        setShowModal(true);
    };

    const handleEditar = (consecutivo) => {
        setEditMode(true);
        setCurrentConsecutivo(consecutivo);
        setSelectedProfesional(consecutivo.users_id);
        setNumeroConsecutivo(consecutivo.consecutivo);
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedProfesional) {
            alert('Debe seleccionar un profesional');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        const data = {
            users_id: selectedProfesional,
            consecutivo: numeroConsecutivo
        };

        try {
            let response;
            if (editMode && currentConsecutivo) {
                // Actualizar
                response = await axios.put(`/consecutivos-rs/${currentConsecutivo.id}?uid=${userdata.user_id}`, data, config);
            } else {
                // Crear
                response = await axios.post('/consecutivos-rs?uid=' + userdata.user_id, data, config);
            }

            if (response.status === 200 || response.status === 201) {
                alert('Consecutivo guardado exitosamente');
                setShowModal(false);
                cargarDatos();
            }
        } catch (error) {
            alert('Error al guardar: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleEliminar = async (id) => {
        if (!window.confirm('¿Está seguro de eliminar este consecutivo?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        try {
            const response = await axios.delete(`/consecutivos-rs/${id}?uid=${userdata.user_id}`, config);
            if (response.status === 200) {
                alert('Consecutivo Eliminado Exitosamente');
                cargarDatos();
            }
        } catch (error) {
            alert('Error al eliminar: ' + (error.response?.data?.message || error.message));
        }
    };

    const getProfesionalNombre = (userId) => {
        const prof = profesionales.find(p => p.users_id === userId);
        return prof ? prof.nombre_agenda : 'Desconocido';
    };

    if (!loggedIn || loading) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="settings" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                    <li className="breadcrumb-item active">Consecutivos RS</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Administrar Consecutivos RS (RIPS SIN FACTURA)</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-list-ol"></i> Consecutivos por Profesional
                                </h3>
                                <div className="card-tools">
                                    <button className="btn btn-success btn-sm" onClick={handleNuevo}>
                                        <i className="fas fa-plus"></i> Nuevo Consecutivo
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                {consecutivos.length === 0 ? (
                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle"></i> No Se Detectaron Consecutivos Previos. 
                                        El Sistema Iniciará La Numeración Desde 1 Para El Primer RIPS Sin Factura De Cada Profesional..
                                    </div>
                                ) : (
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Profesional</th>
                                                <th>Consecutivo Actual</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {consecutivos.map(cons => (
                                                <tr key={cons.id}>
                                                    <td>{getProfesionalNombre(cons.users_id)}</td>
                                                    <td><strong>{cons.consecutivo}</strong></td>
                                                    <td>
                                                        <button 
                                                            className="btn btn-warning btn-sm mr-2"
                                                            onClick={() => handleEditar(cons)}
                                                        >
                                                            <i className="fas fa-edit"></i> Editar
                                                        </button>
                                                        <button 
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => handleEliminar(cons.id)}
                                                        >
                                                            <i className="fas fa-trash"></i> Eliminar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                        <div className="card card-warning card-outline">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-exclamation-triangle"></i> Gestión de Consecutivos RS (RIPS Sin Factura)
                                </h3>
                            </div>
                            <div className="card-body">
                                <ul>
                                    <li><strong>USO:</strong> Este Consecutivo Aplica Exclusivamente Para La Generación De Archivos RIPS <strong>Que NO Requieren Factura Electrónica</strong> (JSON).</li>
                                    <li><strong>Asignación:</strong> Cada profesional cuenta con su propia numeración independiente.</li>
                                    <li><strong>Inicio Automático:</strong>Si No Se Configura Un Número Inicial, El Sistema Comenzará Automáticamente Desde El Numero 1.</li>
                                    <li><strong>Actualización:</strong>El Número Se Incrementará De Forma Automática Tras Cada Generación Exitosa De RIPS.</li>
                                    <li><strong>Restricción:</strong> El Sistema Permite Un Único Registro De Consecutivo Por Cada Profesional.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            
            {/* Modal */}
            {showModal && (
                <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header bg-info">
                                <h4 className="modal-title">
                                    {editMode ? 'Editar Consecutivo' : 'Nuevo Consecutivo'}
                                </h4>
                                <button type="button" className="close" onClick={() => setShowModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label>Profesional *</label>
                                        <select 
                                            className="form-control"
                                            value={selectedProfesional}
                                            onChange={(e) => setSelectedProfesional(e.target.value)}
                                            required
                                            disabled={editMode}
                                        >
                                            <option value="">Seleccione...</option>
                                            {profesionales.map(prof => (
                                                <option key={prof.users_id} value={prof.users_id}>
                                                    {prof.nombre_agenda}
                                                </option>
                                            ))}
                                        </select>
                                        {editMode && (
                                            <small className="form-text text-muted">
                                                No se puede cambiar el profesional al editar
                                            </small>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label>Consecutivo Actual *</label>
                                        <input 
                                            type="number"
                                            className="form-control"
                                            value={numeroConsecutivo}
                                            onChange={(e) => setNumeroConsecutivo(e.target.value)}
                                            min="1"
                                            required
                                        />
                                        <small className="form-text text-muted">
                                            Este será el próximo número de consecutivo RS
                                        </small>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                        Cancelar
                                    </button>
                                    <button type="submit" className="btn btn-success">
                                        <i className="fas fa-save"></i> Guardar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            
            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ConsecutivosRS;
